import D from "@/admin/dashboard/Dashboard.module.css";

import { ComputeAllocationSection } from "@/admin/dashboard/ComputeAllocationSection.tsx";
import { CustomersSection } from "@/admin/dashboard/CustomersSection.tsx";
import { FailoverReadinessSection } from "@/admin/dashboard/FailoverReadinessSection.tsx";
import { FloatingSection } from "@/admin/dashboard/FloatingSection.tsx";
import { InvoicedRevenueSection } from "@/admin/dashboard/InvoicedRevenueSection.tsx";
import { ManagedServicesSection } from "@/admin/dashboard/ManagedServicesSection.tsx";
import { NotificationsSection } from "@/admin/dashboard/NotificationsSection.tsx";
import { StorageSection } from "@/admin/dashboard/StorageSection.tsx";
import { UsageBasedRevenueSection } from "@/admin/dashboard/UsageBasedRevenueSection.tsx";
import { UserConversionSection } from "@/admin/dashboard/UserConversionSection.tsx";
import { VirtualMachinesSection } from "@/admin/dashboard/VirtualMachinesSection.tsx";
import { menuItemPrivilegeAtom } from "@/admin/privileges.ts";
import { ContentPane } from "@/components/ContentPane.tsx";
import { resourceTypesEnabledAtom } from "@/modules/api/resourceTypes.tsx";
import { useTitle } from "@/utils/react/useTitle.ts";
import { useAtomValue } from "jotai/react";

export function DashboardView() {
    useTitle("Dashboard");

    const enabled = useAtomValue(resourceTypesEnabledAtom);
    const hasPrivilege = useAtomValue(menuItemPrivilegeAtom("dashboard"));

    if (!hasPrivilege) {
        return <div className="h-full flex justify-center items-center">Please select an item from the menu</div>;
    }

    return (
        <ContentPane className={D.Dashboard}>
            {(enabled.bucket || enabled.virtual_machine || enabled.managed_service || enabled.ip_address) && (
                <NotificationsSection />
            )}

            {enabled.virtual_machine && <ComputeAllocationSection />}

            {enabled.virtual_machine && <FailoverReadinessSection />}

            <UserConversionSection />

            <InvoicedRevenueSection />

            <CustomersSection />

            {enabled.virtual_machine && <VirtualMachinesSection />}

            {enabled.managed_service && <ManagedServicesSection />}

            {(enabled.bucket || enabled.virtual_machine || enabled.managed_service) && <StorageSection />}

            {enabled.ip_address && <FloatingSection />}

            <UsageBasedRevenueSection />
        </ContentPane>
    );
}
